<template>
  <div class="search-form-container">
    <el-form :model="formData" :inline="true" size="mini">
      <!-- 动态渲染表单项 -->
      <template v-for="(item, index) in formItems">
        <el-form-item :label="item.label" :key="index" v-if="!item.slot">
          <!-- 日期范围选择器 -->
          <el-date-picker
            v-if="item.type === 'daterange'"
            v-model="formData[item.prop]"
            :type="item.type"
            :range-separator="item.rangeSeparator || '至'"
            :start-placeholder="item.startPlaceholder || '开始日期'"
            :end-placeholder="item.endPlaceholder || '结束日期'"
            :value-format="item.valueFormat || 'yyyy-MM-dd'"
            v-bind="item.props || {}"
          />

          <!-- 下拉选择器 -->
          <el-select
            v-else-if="item.type === 'select'"
            v-model="formData[item.prop]"
            :placeholder="item.placeholder"
            :clearable="item.clearable !== false"
            v-bind="item.props || {}"
          >
            <el-option
              v-for="option in item.options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>

          <!-- 输入框 -->
          <el-input
            v-else
            v-model="formData[item.prop]"
            :placeholder="item.placeholder"
            v-bind="item.props || {}"
            v-no-emoji
          />
        </el-form-item>

        <!-- 自定义插槽 -->
        <template v-else>
          <el-form-item :label="item.label" :key="index">
            <slot :name="item.slot" :form-data="formData"></slot>
          </el-form-item>
        </template>
      </template>

      <!-- 操作按钮 -->
      <el-form-item>
        <slot name="buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch" size="mini"
            >筛选</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="handleReset" size="mini"
            >清空</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd"
            size="mini"
            v-if="isPermi"
            >新增</el-button
          >
        </slot>
      </el-form-item>

      <!-- 右侧额外按钮 -->
      <slot name="extra"></slot>
    </el-form>
  </div>
</template>

<script>
  import { ref, watch, computed } from '@vue/composition-api'
  import store from '@/store'

  export default {
    name: 'SearchForm',
    props: {
      // 表单配置项
      formItems: {
        type: Array,
        required: true,
        default: () => []
      },
      // 表单初始值
      initialValues: {
        type: Object,
        default: () => ({})
      },
      permi: {
        type: String,
        default: ''
      },
      useCache: {
        type: Boolean,
        default: false
      },
      cacheOptions: {
        type: Object,
        default: () => ({})
      }
    },
    setup(props, { emit }) {
      const formData = ref({})
      if (props.useCache) {
        const { type, key } = props.cacheOptions || {}
        let cacheData = {}
        if (type === 'local') {
          const temp = localStorage.getItem(key)
          if (temp) {
            cacheData = JSON.parse(temp)
          }
        } else if (type === 'session') {
          const temp = sessionStorage.getItem(key)
          console.log('temp', temp)
          if (temp) {
            cacheData = JSON.parse(temp)
          }
        }

        // 表单数据
        formData.value = {
          ...props.initialValues,
          ...cacheData
        }
      } else {
        formData.value = {
          ...props.initialValues
        }
      }

      // 监听初始值变化
      watch(
        () => props.initialValues,
        (newVal) => {
          formData.value = newVal
        }
      )

      // 判断是否有权限
      const isPermi = computed(() => {
        // permi 为非必传参数，默认为空，则默认有权限
        if (!props.permi) return true
        const { acpermission = [] } = store.state.user || {}
        if (!acpermission || !acpermission.length) {
          return false
        }
        return acpermission.includes(props.permi)
      })

      // 搜索
      const handleSearch = () => {
        setCache(formData.value)
        emit('search', formData.value)
      }

      // 重置
      const handleReset = () => {
        Object.keys(formData.value).forEach((key) => {
          formData.value[key] = Array.isArray(props.initialValues[key])
            ? []
            : props.initialValues[key] || ''
        })
        setCache(formData.value)
        emit('reset', formData.value)
      }

      // 新增
      const handleAdd = () => {
        emit('add')
      }

      const setCache = (data) => {
        const { type, key } = props.cacheOptions || {}
        if (key && type && props.useCache) {
          if (type === 'local') {
            localStorage.setItem(key, JSON.stringify(data))
          } else if (type === 'session') {
            sessionStorage.setItem(key, JSON.stringify(data))
          }
        }
      }

      return {
        formData,
        handleSearch,
        handleReset,
        handleAdd,
        isPermi
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-form-container {
    margin-bottom: 16px;

    ::v-deep .el-form-item {
      margin-bottom: 16px;
    }
  }
</style>
